var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTimeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5 12.5C22.5 18.02 18.02 22.5 12.5 22.5C6.98 22.5 2.5 18.02 2.5 12.5C2.5 6.98 6.98 2.5 12.5 2.5C18.02 2.5 22.5 6.98 22.5 12.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.2099 15.6817L13.1099 13.8317C12.5699 13.5117 12.1299 12.7417 12.1299 12.1117V8.01172",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTimeIcon);
export default __webpack_public_path__ + "static/media/add_time_icon.6e484391d1abecaeb104c58b54a0afb0.svg";
export { ForwardRef as ReactComponent };